// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1kF6S","header":"ClearentDisclaimer_header__pgrhm","inner":"ClearentDisclaimer_inner__AGSrm"};